import * as type from './types';
import * as user_type from '../user/types';
import property from 'lodash/property';
import React from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import {_sendLog} from "../../utils/utility";


const authCpHeader = (state) => {
    const cpToken = _getCpToken(state);

    // Add cpToken to cpTokens list in Redux state if not already present
    if (cpToken && state.sys && Array.isArray(state.sys.cpTokens) && !state.sys.cpTokens.includes(cpToken)) {
        state.sys.cpTokens.push(cpToken);
    }

    if (cpToken) {
        return { 'Authorization': 'Bearer ' + cpToken };
    } else {
        return {};
    }
}

export function _showError(errors) {
    console.log(errors);
    return (dispatch, getState) => {
        dispatch({
            type: type.SHOW_ERROR,
            errors: errors
        });
    }
}


export function _clearError() {
    return (dispatch, getState) => {
        dispatch({
            type: type.CLEAR_ERROR
        });
    }
}


export function _showModal(data) {
    return (dispatch, getState) => {
        dispatch({
            type: type.SHOW_MODAL,
            data: data
        });
    }
}

export function _hideModal() {
    return (dispatch, getState) => {
        dispatch({
            type: type.HIDE_MODAL,
        });
    }
}


export function _showSpinner() {
    return (dispatch, getState) => {
        dispatch({
            type: type.SHOW_SPINNER
        });
    }
}

export function _hideSpinner() {
    return (dispatch, getState) => {
        dispatch({
            type: type.HIDE_SPINNER
        });
    }
}

export function _setLang(lang) {
    return (dispatch, getState) => {
        dispatch({
            type: type.SET_LANG,
            lang: lang?.toLowerCase()
        });
    }
}

export const _setOtpToken = (otpToken) => {
    return (dispatch) => {
        dispatch({
            type: type.SET_OTP_TOKEN,
            data: otpToken
        });
    }
}

export const _setCpToken = (cpToken, iv) => {
    return (dispatch) => {
        dispatch({
            type: type.SET_CP_TOKEN,
            token: cpToken
        });
    }
}

export const _verifyOtp = (otp) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                headers: authCpHeader(getState()),
                params: {
                    otp: otp
                }
            }

            axios.get(process.env.REACT_APP_VERIFY_OTP, config)
                .then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    _sendLog(['Customer Portal React - System Service - _verifyOtp', JSON.stringify(error)],
                        'error');
                    reject(error);
            })
        })
    }
}


export const _verifyOtpAndGetUserDetail = (otp, email) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const config = {
                headers: {
                    ...authCpHeader(getState()),
                    'Content-Type': 'application/json',
                },
                timeout: 30000,
            };

            const data = {
                otp: otp,
                email: email.toLowerCase(),
                country: _getCountry(getState()),
            };

            axios.post(process.env.REACT_APP_VERIFY_OTP_AND_GET_USER_DETAIL, data, config)
                .then((response) => {
                    if (response.data.success) {
                        let otpToken = {
                            iv: '',
                            token: ''
                        }
                        dispatch({
                            type: type.SET_OTP_TOKEN,
                            data: otpToken
                        });
                        dispatch({
                            type: user_type.SET_USER,
                            data: response.data.userDetails
                        })
                    }
                    resolve(response.data);
                }).catch((error) => {
                    _sendLog(['Corporate Portal React - System Service - _verifyOtpAndGetUserDetail', JSON.stringify(error)],
                        'error');
                    reject(error);
                }
            )
        })
    }
}

export function _setNoLogin(noLogin) {
    return (dispatch, getState) => {
        dispatch({
            type: type.SET_NO_LOGIN,
            noLogin: noLogin
        });
    }
}

export function _setCountry(country) {
    return (dispatch, getState) => {
        dispatch({
            type: type.SET_COUNTRY,
            country: country
        });
    }
}

export function _setSecurityToken(token) {
    return (dispatch, getState) => {
        dispatch({
            type: type.SET_SECURITY_TOKEN,
            token: token
        });
    }
}

export function _clearPolicyToken() {
    return (dispatch, getState) => {
        dispatch({
            type: type.RESET_POLICY_TOKEN
        });
    }
}

export function _clearPortfolioToken() {
    return (dispatch, getState) => {
        dispatch({
            type: type.RESET_POLICY_TOKEN
        });
    }
}


export function _clearToken() {
    return (dispatch, getState) => {
        console.log("clear tokens");
        dispatch({
            type: type.RESET_STATE
        });
    }
}

export function _setPolicyToken(token) {
    return (dispatch) => {
        console.log("_setPolicyToken: "+ token);
        dispatch({
            type: type.SET_POLICY_TOKEN,
            data: token
        });
    }

}

export const _isAuthenticated = () => {
    let token = _getSecurityToken();
    if (token) {
        const decoded = jwt_decode(token);
        const expiryDate = new Date( decoded.exp * 1000);
        return expiryDate > new Date();
    }
    return false;
}

export function _setShowOtpModal(value) {
    return (dispatch) => {
        dispatch({
            type: type.SET_SHOW_OTP_MODAL,
            showOtpModal: value
        });
    }
}

export const _generatePortfolioToken = (userId, clientId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            let config = {
                params: {
                    userId: userId,
                    clientId: clientId
                }
            }

            axios.get(process.env.REACT_APP_GENERATE_PORTFOLIO_ACCESS_TOKEN, config).then(
                resp => {
                    if (resp.data.success) {
                        dispatch({
                            type: type.SET_PORTFOLIO_TOKEN,
                            data: resp.data.customerPortalToken
                        });
                    }
                    resolve();
                }
            ).catch(error => {
                _sendLog(['Customer Portal React - System Service - _generatePortfolioToken', JSON.stringify(error)],
                    'error');
                reject(error);
            })
        });
    }
}

export const _setPortfolioToken = (token) => {
    return (dispatch) => {
        console.log("_setPortfolioToken: "+ token);
        dispatch({
            type: type.SET_PORTFOLIO_TOKEN,
            data: token
        });
    }
}

export const _clearState = () => {
    return (dispatch) => {
        dispatch({
            type: type.RESET_STATE
        });
    }
}

export const _setShowPageBroken = (value) => {
    return (dispatch) => {
        dispatch({
            type: type.SET_PAGE_BROKEN,
            showPageBroken: value
        });
    }
}

export const _generatePolicyTokenFromPortfolioScreen = (policyNumber, country) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                headers: authCpHeader(getState()),
                params: {
                    policyNumber: policyNumber,
                    country: country
                },
                timeout: 30000
            }

            axios.get(process.env.REACT_APP_GENERATE_POLICY_TOKEN_PORTFOLIO_SCREEN, config)
                .then(response => {
                    // window.sessionStorage.removeItem(POLICY_TOKEN_KEY);
                    // window.sessionStorage.setItem(POLICY_TOKEN_KEY, response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    _sendLog(['Customer Portal React - System Service - _generatePolicyTokenFromPortfolioScreen', JSON.stringify(error)],
                        'error');
                    reject(error);
                })
        })
    }
}

export const _setAdminLogin = (value) => {
    return (dispatch) => {
        dispatch({
            type: type.SET_ADMIN_LOGIN,
            adminLogin: value
        })
    }
}

export const _setTimerStarted = (value, id) => {
    return (dispatch) => {
        dispatch({
            type: type.SET_TIMER_STARTED,
            data: {
                value: value,
                id: id
            }
        })
    }
}

export const _checkSystemAvailable = () => {
    return async (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            const httpOptions = { headers: {'Content-Type': 'application/json'} };

            axios.post(server + process.env.REACT_APP_CHECK_SYSTEM_STATUS_URL, {countryCode: "SGP"}, httpOptions)
                .then(resp => {
                    const systemAvailable = resp.data?.toString() === "true";
                    dispatch({
                        type: type.SET_SYSTEM_AVAILABLE,
                        systemAvailable: systemAvailable
                    });
                    resolve(systemAvailable);
                })
                .catch(error => {
                    _sendLog(['PAN-React - System Service - _checkSystemAvailable: ', error]);
                    reject(error);
                });
        });
    }
}

// create an endpoint call to check pvt status
export const _checkPVTStatus = (country) => {
    return async (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            const config = {
                params: { countryCode: country },
                headers: { 'Content-Type': 'application/json' }
            };
            axios.get(server + process.env.REACT_APP_CHECK_PVT_STATUS_URL, config)
                .then(resp => {
                    if(resp) {
                        const isPvtModeOn = resp.data?.toString() === "true";
                        dispatch({
                            type: type.SET_PVT_STATUS,
                            isPvtModeOn: isPvtModeOn
                        });
                        resolve(resp);
                    }
                })
                .catch(error => {
                    _sendLog(['GMP-SG - System Service - _checkPVTStatus: ', error]);
                    reject(error);
                });
        });
    }
}

export const _getBanners = () => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                params: {
                  country: "SGP",
                  product: "GMP"
                },
                headers: authCpHeader(getState()),
                timeout: 600000,
            }

            axios.get(process.env.REACT_APP_GET_BANNERS_URL, config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    _sendLog(['Corporate Portal React - Policy Service - _getBanners', JSON.stringify(error)],
                        'error');
                    reject(error);
                })
        })
    }
}

export const _getScheduledMaintenance = () => {
    return async (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            const httpOptions = { headers: {'Content-Type': 'application/json'} };
            axios.post(server + process.env.REACT_APP_CHECK_SCHEDULED_MAINTENANCE_URL, {countryCode: "SGP"}, httpOptions)
                .then(resp => {
                    if(resp) {
                       resolve(resp);
                    }
                })
                .catch(error => {
                    _sendLog(['PAN-React - System Service - _checkSystemAvailable: ', error]);
                    reject(error);
                });
        });
    }
}

export const _getErrors = property('sys.errors');

export const _getShowError = property('sys.showError');

export const _getShowModal = property('sys.showModal');

export const _getModal = property('sys.modal');

export const _getShowSpinner = property('sys.spinner');

export const _getViewOnly = property('sys.viewOnly');

export const _getTransactionType = property('sys.transactionType');

export const _getLang = property('sys.lang');

export const _getToken = property('sys.otpToken');

export const _getCpToken = property('sys.cpToken');

export const _isNoLogin = property('sys.noLogin');

export const _getCountry = property('sys.country');

export const _isHongKong = property('sys.country') === 'HKG';

export const _isSingapore = property('sys.country') === 'SGP';
export const _getSecurityToken = property('sys.securityToken');

export const _getPolicyToken = property('sys.policyToken');

export const _getShowOtpModal = property('sys.showOtpModal');

export const _getPortfolioToken = property('sys.portfolioToken');

export const _getShowPageBroken = property('sys.showPageBroken');

export const _getAdminLogin = property('sys.adminLogin');

export const _isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const _getTimerStarted = property('sys.timerStarted');

export const _getTimerId = property('sys.timerId');

export const _getSystemAvailable = property('sys.systemAvailable');

export const _getIsPvtModeOn = property('sys.isPvtModeOn');
